import { Expose, Transform, Type } from 'class-transformer';
import { BaseDto, BaseFiltersDto } from './base.dto';

import {
  IsDate,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
} from 'class-validator';
import { ReservationStatus } from '@coworkrz/reservations/types';
import { CategoryDto } from './categories.dto';
import { CastHelper } from './cast.helper';
import { ReservationDateFilterField } from '@coworkrz/core/constants';
import { MemberDto } from './members.dto';

export class CreateReservationDto {
  @IsString()
  @IsNotEmpty()
  startDate: Date;

  @IsString()
  @IsNotEmpty()
  endDate: Date;

  @IsString()
  @IsNotEmpty()
  spaceId: string;

  @IsString()
  @IsNotEmpty()
  userId: string;

  @IsNumber()
  @IsNotEmpty()
  numberOfSeats: number;

  @IsString()
  @IsOptional()
  startTime: string;

  @IsString()
  @IsOptional()
  endTime: string;
}

export class UpdateReservationDto {
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  startDate?: Date;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  endDate?: Date;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  spaceId?: string;

  @IsOptional()
  @IsString()
  startTime?: string;

  @IsOptional()
  @IsString()
  endTime?: string;

  @IsOptional()
  @IsEnum(ReservationStatus)
  status?: ReservationStatus;
}

export class SpaceDto extends BaseDto {
  @Expose()
  name: string;

  @Expose()
  description: string;

  @Expose()
  code: string;

  @Expose()
  @Type(() => CategoryDto)
  category: CategoryDto;
}

export class ReservationPreviewDto extends BaseDto {
  @Expose()
  startTime: string;

  @Expose()
  endTime: string;

  @Expose()
  startDate: Date;

  @Expose()
  endDate: Date;

  @Expose()
  startTimeDate: Date;

  @Expose()
  endTimeDate: Date;

  @Expose()
  numberOfSeats: number;

  @Expose()
  spaceId: string;

  @Expose()
  @Type(() => SpaceDto)
  space: SpaceDto;

  @Expose()
  @Type(() => MemberDto)
  member: MemberDto;

  @Expose()
  status: ReservationStatus;
}

export class ReservationDto extends ReservationPreviewDto {}

export class ReservationsFilterDto extends BaseFiltersDto {
  @IsOptional()
  @IsEnum(ReservationStatus)
  status?: ReservationStatus;

  @Transform(({ value }) => CastHelper.toDate(value))
  @IsOptional()
  @IsDate()
  from?: Date | null;

  @Transform(({ value }) => CastHelper.toDate(value))
  @IsOptional()
  @IsDate()
  to?: Date | null;

  @Transform(({ value }) => CastHelper.trim(value))
  @IsOptional()
  @IsEnum(ReservationDateFilterField)
  dateField?: ReservationDateFilterField | null;
}
